import { databaseViewFilterFunctions } from '@streamlain/database-identity';

import { dataViewI18nT } from '../../i18n.js';
import { ct } from '../../logical/composite-type.js';
import { t } from '../../logical/type-presets.js';
import { tRef, tVar } from '../../logical/type-variable.js';
import { createFilter } from './create.js';
import { tagToString } from './utils.js';

const optionName = 'options' as const;
export const tagFilter = [
  createFilter({
    name: 'isOneOf',
    vars: [tVar(optionName, t.tag.instance())] as const,
    self: tRef(optionName),
    args: [ct.array.instance(tRef(optionName))] as const,
    get label() {
      return dataViewI18nT('filter.operator.isOneOf');
    },
    shortString: v =>
      v ? `: ${tagToString(v.value, v.type.element)}` : undefined,
    impl: databaseViewFilterFunctions.isOneOf,
    defaultValue: args => args[0][0],
  }),
  createFilter({
    name: 'isNotOneOf',
    vars: [tVar(optionName, t.tag.instance())] as const,
    self: tRef(optionName),
    args: [ct.array.instance(tRef(optionName))] as const,
    get label() {
      return dataViewI18nT('filter.operator.isNotOneOf');
    },
    shortString: v =>
      v
        ? `: ${dataViewI18nT('filter.summary.not', { values: tagToString(v.value, v.type.element) ?? '' })}`
        : undefined,
    impl: databaseViewFilterFunctions.isNotOneOf,
  }),
];
